import React, { Component } from 'react';
import "./index.less";
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull,messageShow, millisecondToDate,getPlatformName,fromClassName } from '../../utils/http';
import Loading from './../showLoading/showLoading';
import { Input, Select, Button, Pagination, Checkbox, Radio, Message, Tooltip, Tag, Dialog } from 'element-react';
import { LevelListingCategoryRequest } from '../../utils/api';


class SelectCategoryModuleV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ShopId: props.targetShopId,
      platformType: props.targetPlatformType,
      ParentId: "0",//目录父级ID
      isMoreSelectShow: props.showSelectCategoryModule,//类目选择框隐藏
      showSelectsList: [],
      CateList: [],                //选中的目录结构
      inputSearchValue: "",            //搜索value
      returnCount: 50,    //搜索类目最多条数
      noSearchCtegory: false,
      searchCtegoryList: [],
      selectCategorys: props.selectCategorys || [
        // {示例
        //     "category_id": 26077,
        //     "full_name": "居家日用 > 伞/雨具/防雨/防潮 > 伞",
        //     "first_cid": 26077,
        //     "second_cid": 20924,
        //     "third_cid": 26077,
        //     "name": "伞"
        // }
      ]
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。
    
    setTimeout(async ()=>{
      await this.levelListingCategory()
      const all_categorys = this.state.all_categorys;
      const selectCategorys = this.state.selectCategorys || [];
      for(let selecteItem of selectCategorys){
        const category = this.findCategory(all_categorys,selecteItem.cate_path)
        category.checked = 1
        this.setParentChecked(all_categorys,category)
        this.setChildrenChecked(category,category.checked)
      }
      if(selectCategorys.length > 0){
        this.showPath(all_categorys,selectCategorys[0].cate_path)
      }
    })
  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    this.setState({
      isMoreSelectShow: props.showSelectCategoryModule,//类目选择框隐藏
      noSearchCtegory:false
    })
  }

  async levelListingCategory(){
    const data = { ShopId:this.state.ShopId}
    const res = await LevelListingCategoryRequest(data);
    if(res.Success){
      const categoryMap = this.converCategroys(res.Data)
      this.state.all_categorys = categoryMap
      console.log('categoryMap =>',categoryMap);
      this.state.showSelectsList = [[]]
      for(let category_id of Object.keys(categoryMap)){
        let category = categoryMap[category_id]
        this.state.showSelectsList[0].push({
          category_id : category.category_id,
          category_name : category.category_name,
          cate_path : category.cate_path,
          IsParent:category.children && Object.keys(category.children).length > 0 ? true:false,
        })
      }
      console.log(this.state.showSelectsList);
      this.setState({})
    }
  }
  //转成map，方便查找
  converCategroys(categorys,parent_category){
    const map = { };
    for(let cateogry of categorys){
      map[cateogry.category_id] = cateogry
      map[cateogry.category_id].cate_path = parent_category && parent_category.cate_path && [...parent_category.cate_path] || []
      map[cateogry.category_id].cate_name = parent_category && parent_category.cate_name && [...parent_category.cate_name] || []
      map[cateogry.category_id].cate_path.push(cateogry.category_id)
      map[cateogry.category_id].cate_name.push(cateogry.category_name)
      map[cateogry.category_id].children = (cateogry.children && this.converCategroys(cateogry.children,cateogry)) || []
    }
    return map;
  }

  //
  selectCategoryCheckBox(item,e){
    e.stopPropagation()

    const start = new Date()
    console.log('start =>',start.valueOf());
    const all_categorys = this.state.all_categorys
    const current_category = this.findCategory(all_categorys,item.cate_path)

    if(item.cate_path.length == 1 && current_category.checked != 1){
      for(let category_id of Object.keys(all_categorys)){
        all_categorys[category_id].checked = 0
        this.setChildrenChecked(all_categorys[category_id], 0)
      }
    }
    if(current_category.checked == 1)
    {
      current_category.checked = 0
    }
    // else if(current_category.checked == 2)
    // {
    //   current_category.checked = 1
    // }
    else
    {
      current_category.checked = 1
    }
    
    this.setChildrenChecked(current_category, current_category.checked)
    this.setParentChecked(all_categorys,current_category)
    this.showPath(all_categorys,item.cate_path)

    const end = new Date()
    console.log('end =>',end.valueOf());
    console.log('timespan =>',end.valueOf() - start.valueOf());
  }
  setChildrenChecked(category,value){
    const child_category_ids = Object.keys(category.children);
    for(let category_id of child_category_ids){
      category.children[category_id].checked = value
      this.setChildrenChecked(category.children[category_id],value)
    }
  }
  //设置父级类目路径状态
  setParentChecked(all_categorys,category){
    let current_category = all_categorys
    for (let index = category.cate_path.length - 2; index >= 0; index--) {
      const temp_path = [...category.cate_path]
      temp_path.splice(index + 1)
      current_category = this.findCategory(all_categorys,temp_path)
      const child_category_ids = Object.keys(current_category.children);
      const checked_categorys = child_category_ids.filter(x => current_category.children[x].checked == 1);
      current_category.checked = checked_categorys.length == child_category_ids.length 
                                  ? 1 : this.hasChildrenChecked(current_category.children) ? 2 :    0;
    }
  }
  //子节点是否有选中
  hasChildrenChecked(current_category){
    const category_ids = Object.keys(current_category)
    for(let cateogry_id of category_ids){
      if(current_category[cateogry_id].checked == 1)
        return true
      else{
        const child_checked = this.hasChildrenChecked(current_category[cateogry_id].children)
        if(child_checked == true) return true;
      }
    }
  }
  //根据路径查找类目
  findCategory(all_categorys,cate_path){
    let current_category = all_categorys;
    for (let index = 0; index < cate_path.length; index++) {
      const path = cate_path[index];
      if(index == cate_path.length - 1){
        current_category = current_category[path]
      }else{
        current_category = current_category[path].children
      }
    }
    return current_category
  }
  //展示类目路径
  showPath(all_categorys,cate_path){
    const showSelectsList = []
    let current_category = all_categorys;
    for (let index = 0; index < cate_path.length; index++) {
      
      const level_category = []
      for(let category_id of Object.keys(current_category)){
        let category = current_category[category_id]

        level_category.push({
          category_id : category.category_id,
          category_name : category.category_name,
          cate_path : category.cate_path,
          checked : category.checked,
          IsParent:category.children && Object.keys(category.children).length > 0 ? true:false,
        })
      }
      const category_id = cate_path[index];
      current_category = current_category[category_id].children
      showSelectsList.push(level_category)
    }
    //展示下一级
    const level_category = []
    const next_category = this.findCategory(all_categorys,cate_path);
    for(let category_id of Object.keys(next_category.children)){
      let category = next_category.children[category_id]

      level_category.push({
        category_id : category.category_id,
        category_name : category.category_name,
        cate_path : category.cate_path,
        checked : category.checked,
        IsParent:category.children && Object.keys(category.children).length > 0 ? true:false,
      })
    }
    if(level_category.length > 0)
      showSelectsList.push(level_category)
    if(showSelectsList.length > 0)
      this.state.showSelectsList = showSelectsList;
    this.setState({ })
  }
  //确认选择类目
  confirmSelectCategory(){
    const all_categorys = this.state.all_categorys;
    const data = this.getSelectCategory(all_categorys);
    
    if(typeof(this.props.confirmCategorys) == 'function'){
      this.props.confirmCategorys(data);
    }
    // 
  }

  getSelectCategory(current_category){
    const current_categoryIds = Object.keys(current_category)
    let data = []
    for(let category_id of current_categoryIds){
      const category = current_category[category_id];
      if(category.checked == 1)
        data.push({
          category_id:category.category_id,
          category_name:category.category_name,
          cate_path:category.cate_path,
          full_name:category.cate_name.join(' > '),
        })
      else{
        const children = this.getSelectCategory(category.children)
        data = data.concat(...children)
      }
    }
    return data
  }
  toChineseNumber(num){
    switch(num){
      case 1: return '一';
      case 2: return '二';
      case 3: return '三';
      case 4: return '四';
      case 5: return '五';
      case 6: return '六';
      case 7: return '七';
      case 8: return '八';
      case 9: return '久';
      case 0: return '零';
    }
  }
  render() {
    let { noSearchCtegory, searchCtegoryList } = this.state;
    return (
      this.state.isMoreSelectShow ?
        <div className="moreSelect-main newCategoryWrap selectCategoryModuleV2Wrap">

          <div className='selectCategoryWrap_levelTitleWarp'>
            {
              this.state.showSelectsList.map((item, index) =>
                <div>
                  { this.toChineseNumber(index + 1)}级类目
                </div>
            )}
          </div>

          {
            // !noSearchCtegory?
            <div className="moreSelect-main selectCategoryWrap">
            {this.state.showSelectsList.map((item, index) =>
                
                <ul className='scroll-x selectCategoryWrap_ul' >
                  {
                    item.map((item02, index) =>
                        <li className={item02.check ? "active selectCategoryWrap_ul_li":"selectCategoryWrap_ul_li"} onClick={()=>{ this.showPath(this.state.all_categorys,item02.cate_path)}}>
                          <label className='ecom-g-checkbox-warpper' onClick={(e)=>{this.selectCategoryCheckBox(item02,e) }}>
                            <span  className={ fromClassName({
                                                'ecom-g-checkbox':true,
                                                'ecom-g-checkbox-checked':item02.checked == 1,
                                                'ecom-g-checkbox-indeterminate':item02.checked == 2,
                                              })}>
                              <span className='ecom-g-checkbox-inner'>
                              </span>
                            </span>
                            
                          </label>
                        <span>{item02.category_name}</span>
                        {item02.IsParent ?
                          <i className="iconfont icon-down"></i> : null
                        }
                      </li>
                    )
                  }
                </ul>
            )}
          </div>
          // :null
          }
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn sureMyBtn" onClick={() => this.confirmSelectCategory()}>确定</span>
          </div>



          <Loading isLoading={this.state.isLoading} hasBorder={true} isShade={false} isStopOperate={true} title={this.state.loadingTitle} />
        </div> : null
    );
  }



};

export default SelectCategoryModuleV2;



// WEBPACK FOOTER //
// ./src/components/selectCategoryModuleV2/index.jsx